<template>
  <v-app>
    <router-view />
    <Notivue v-slot="item">
      <Notification :item="item" />
    </Notivue>
  </v-app>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { useQuasar } from 'quasar'

import { useGeneralStore } from '@stores/general'

import { Notivue, Notification } from 'notivue'

const $q = useQuasar()

const generalStore = useGeneralStore()

onBeforeMount(() => {
  // This is so users are never stuck with an infinite spinner on the page even after refresh
  generalStore.showGlobalLoadingIndicator = false
  generalStore.showLocalLoadingIndicator = false
})

generalStore.$subscribe((_, state) => {
  if (state.showGlobalLoadingIndicator) {
    $q.loading.show()
  }
  else {
    $q.loading.hide()
  }
})
</script>

<style>
:root {
  --nv-gap: 1rem;
  --nv-z: 9999;
}
</style>
